import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import Button from '../Button'
import './Thanks.sass'
import Col from "../Col"
import Container from "../Container"

export default class Thanks extends PureComponent {
  static propTypes = {
    user: PropTypes.shape({
      phone: PropTypes.string,
      email: PropTypes.string
    }).isRequired,
    linkTo: PropTypes.string.isRequired,
    requestID: PropTypes.number.isRequired
  }

  render() {
    const {phone, email} = this.props.user
    const {linkTo, requestID} = this.props
    return(
      <Container>
        <Col xs={6} sm={12} md={24} lg={24}>
          <div className="thanks">
            <div className="thanks__caption-wrapper">
              <div className="thanks__ok" />
              <h3 className="thanks__caption">Ваше заявление №{requestID} принято для передачи в ведомство</h3>
            </div>
            <div className="thanks__info">
              <p className="thanks__info-text">Следите за его статусом в личном кабинете, на портале госуслуг, по элекронной почте или в SMS-сообщениях</p>
              <div className="thanks__info-phone-wrapper">
                <span className="thanks__info-phone">Мобильный телефон</span>
                {phone ?
                  <span className="thanks__info-email-text">{phone}</span>
                  :
                  <a className="thanks__info-phone-link" href="/">Укажите мобильный телефон</a>
                }
              </div>
              <div className="thanks__info-email-wrapper">
                <span className="thanks__info-email">Электронная почта</span>
                <span className="thanks__info-email-text">{email}</span>
              </div>
            </div>
            <div className="thanks__btn-wrapper">
              <Link to={linkTo}>
                <Button bsSize="lg" bsStyle="arrow-right">
                  Перейти в мои заявления
                </Button>
              </Link>
              <a className="thanks__link" href="/">Изменить настройки уведомлений</a>
            </div>
          </div>
        </Col>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./components/Thanks/index.jsx